import React from "react";

const LegacyCardSkeleton = ({ count = 6, rowsPerCard = 4 }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-6 xl:gap-x-12 xl:gap-y-10 w-full md:pl-4 items-stretch">
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="flex flex-col border border-lightPrimary/40 dark:border-info/40 p-4 rounded-sm dark:bg-card-custom-radials bg-white min-h-[17rem] h-full animate-pulse"
        >
          <div className="h-6 w-1/3 bg-gray-300 dark:bg-gray-700 mb-6 rounded mb-auto"></div>
          <div className="border-b border-lightPrimary/40 dark:border-info/40 mb-3"></div>
          <div className="h-32 w-full bg-gray-300 dark:bg-gray-700 rounded"></div>
          <div className="mt-auto pt-2 border-t border-lightPrimary/40 dark:border-info/40">
            <div className="flex justify-between">
              <div className="h-4 w-1/4 bg-gray-300 dark:bg-gray-700 rounded"></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default LegacyCardSkeleton;
